import React from 'react';

import styled from 'styled-components';

export default function Belief() {
  return (
    <StyledBelief>
      <StyledBeliefContentsContainer>
        <StyledTag>OUR BELIEF</StyledTag>
        <StyledTitle>
          당신은 충분히 <br />
          현명합니다.
        </StyledTitle>
        <StyledMobileTitle>당신은 충분히 현명합니다.</StyledMobileTitle>
        <p>
          “최소수익은 안전을 최우선시하는 수동적인 투자자의 몫이고, 최고 수익은
          <StyledBold> 우수한 지적능력</StyledBold>과
          <StyledBold> 기술</StyledBold>을 갖고 있는 투자자의 몫이라 할 수
          있다.”
          <br />
          역사상 가장 현명한 투자자 중 한 분인 ‘벤저민 그레이엄’이 남긴
          말입니다. 인텔리퀀트는 당신의 현명한 투자를 돕기 위한 금융 서비스들을
          만듭니다.
        </p>
      </StyledBeliefContentsContainer>
    </StyledBelief>
  );
}

const StyledBelief = styled.article`
  padding: 150px 0 150px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  background-image: url('images/Home/belief/fill-1.png');
  background-repeat: no-repeat;
  background-position: bottom right 55%;
  background-size: cover;

  ${({ theme }) => theme.mobile`
  padding: 9.7% ;
  text-align: center;
  background-position: contain;

  `}
`;

const StyledBeliefContentsContainer = styled.div`
  margin: 0 auto;
  max-width: 1340px;
  padding: 0 30px;

  p {
    ${({ theme }) => theme.mobile`
      max-width: 420px;
      margin: 0 auto;
      font-size: ${theme.pixelToRem(14)};
      text-align: center;

    `}
  }
`;

const StyledTag = styled.h2`
  margin-bottom: 18px;
  color: ${({ theme }) => theme.colors.green};
  font-size: ${({ theme }) => theme.pixelToRem(14)};

  ${({ theme }) => theme.mobile`
  margin-bottom: 10px;

  `}
`;

const StyledTitle = styled.h3`
  display: block;
  margin-bottom: 18px;
  font-size: ${({ theme }) => theme.pixelToRem(30)};
  font-weight: 700;

  ${({ theme }) => theme.mobile`
  display: none;
  margin-bottom: 10px;
  font-size: ${theme.pixelToRem(24)}
  `}
`;

const StyledMobileTitle = styled.h3`
  display: none;
  margin-bottom: 18px;
  font-size: ${({ theme }) => theme.pixelToRem(30)};
  font-weight: 700;

  ${({ theme }) => theme.mobile`
  display: block;
  margin-bottom: 10px;
  font-size: ${theme.pixelToRem(24)}
  `}
`;

const StyledBold = styled.span`
  font-weight: 700;
`;
